module.exports = require("@swa-ui/itinerary/src/StopDuration/StopDuration.module.scss");